<template>
  <div class="landing ">
      <b-navbar>
        <template slot="brand">
            <b-navbar-item tag="router-link" :to="{ path: '/login' }">
                <img
                    src="@/assets/LogoColor.svg"
                >
            </b-navbar-item>
        </template>

        <template slot="end">
            <b-navbar-item tag="div">
                <div class="buttons">
                    <router-link to="/register" class="button is-primary">
                        <strong>Sign up</strong>
                    </router-link>
                    <router-link 
                    to="/login"
                    class="button is-light">
                        Log in
                    </router-link>
                </div>
            </b-navbar-item>
        </template>
    </b-navbar>
    <div class="mWrap" >
      <MainM></MainM>
    </div>
  </div>
</template>

<script>
  import MainM from '@/components/MainM.vue'
  export default {
    name: 'landing',
    components:{
      MainM
    },
    data() {
      return {
        
      }
    },
    methods: {
      
    },
    
  }
</script>

<style scoped lang="scss">
  .landing {
    width: 100vw;
    // display: flex;
  }
  .mWrap{
    display:flex;
    justify-content: center;
  }

  
</style>